import React, { useState, useEffect } from 'react';
import styles from './CustomPWAButton.module.css';
import { MdOutlineInstallDesktop } from "react-icons/md";
import { MdOutlineInstallMobile } from "react-icons/md";
import { GoShare } from "react-icons/go";
import { Button, Modal } from 'antd';
// import { toast } from 'react-toastify';

const CustomPWAButton = ({ view }) => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [isSafari, setIsSafari] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isAddtoHomeScreenSafari, setIsAddtoHomeScreenSafari] = useState(false)
  const [isInstalled, setIsInstalled] = useState(window.navigator.standalone)

  const [showInstallAppModal, setShowInstallAppModal] = useState(false);

  var isOpera = (typeof window.opr !== "undefined" && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isFirefox = typeof InstallTrigger !== 'undefined';
  var isIE = /*@cc_on!@*/false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
  var isBlink = (isChrome || isOpera) && !!window.CSS;
  var isSafariBrowser = isOpera || isFirefox || isIE || isEdge || isChrome || isEdgeChromium || isBlink ? false : true;

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      if (getHideModal() !== 'true') {
        setSupportsPWA(true);
      }
      setPromptInstall(e);
    };

    setIsSafari(isSafariBrowser);

    if (!isSafariBrowser) {
      window.addEventListener('beforeinstallprompt', handler);
    } else {
      if (getHideModal() !== 'true') {
        setSupportsPWA(true);
      }
    }

    return () => {
      if (!isSafariBrowser) {
        window.removeEventListener('beforeinstallprompt', handler);
      }
    };
  }, []);

  useEffect(() => {
    if (getInitHideModal() !== 'true' && ((isChrome && promptInstall) || isSafariBrowser)) {
      setShowInstallAppModal(true);
      setInitHideModal(true);
    }
  }, [promptInstall, isChrome, isSafariBrowser]);

  useEffect(() => {
    // Listen for changes in the standalone status
    const checkStandalone = () => {
      setIsInstalled(window.navigator.standalone);
    };

    window.addEventListener('load', checkStandalone);
    window.addEventListener('resize', checkStandalone);

    return () => {
      window.removeEventListener('load', checkStandalone);
      window.removeEventListener('resize', checkStandalone);
    };
  }, []);

  const setHideModal = (value) => {
    localStorage.setItem('hidePWAModal', value);
    setSupportsPWA(false);
  }

  const getHideModal = () => {
    return localStorage.getItem('hidePWAModal') || null;
  };


  const setInitHideModal = (value) => {
    localStorage.setItem('hideInitPWAModal', value);
    setSupportsPWA(false);
  }

  const getInitHideModal = () => {
    return localStorage.getItem('hideInitPWAModal') || null;
  };

  const installApp = async () => {
    if (promptInstall) {
      promptInstall.prompt();
      const choiceResult = await promptInstall.userChoice;
      console.log(choiceResult.outcome);
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
        window.location.reload();
      } else {
        console.log('User dismissed the A2HS prompt');
      }
      setPromptInstall(null);

    }
    if (isSafari) {
      if (window.navigator.standalone) {
        setIsAddtoHomeScreenSafari(false)
        console.log('Already in standalone mode');
      } else {
        setIsAddtoHomeScreenSafari(true)
      }
    }
  };

  return (
    <>
      <button className={isSafari ? styles['pwa-button-safari'] : styles['pwa-button']} onClick={() => setShowInstallAppModal(true)} style={{ display: supportsPWA && !isInstalled ? 'block' : 'none' }}>
        {view === 'mobile' ? <MdOutlineInstallMobile /> : <MdOutlineInstallDesktop />} {!isSafari ? <span>Install</span> : ""}
      </button>
      <Modal
        title="Add BreatheEV App"
        open={isAddtoHomeScreenSafari || showInstallAppModal}
        footer={null}
        onCancel={() => { setIsAddtoHomeScreenSafari(false); setShowInstallAppModal(false); }}
        className={styles['modal']}
      >
        <div>
          <div className={styles['body-line']}>Add BreatheEV app to your Home Screen for quick and easy access</div>
          {isSafari ?
            <>
              <div className={styles['body-line']}>Step 1: Tap <GoShare /> in your browser</div>
              <div className={styles['body-line']}>Step 2: Select "Add to Home Screen"</div>

              <div className={styles['modal-bottom']}>
                <Button onClick={() => { setIsAddtoHomeScreenSafari(false); setShowInstallAppModal(false); setHideModal(true); }}>Don’t show again</Button>
              </div>
            </> :
            <>
              <div className={styles['modal-bottom']}>
                <Button style={{ background: "#18365E" }} type="primary" onClick={installApp}>Click to Install Application</Button>
                <Button onClick={() => { setIsAddtoHomeScreenSafari(false); setShowInstallAppModal(false); setHideModal(true); }}>Don’t show again</Button>
              </div>
            </>
          }
        </div>
      </Modal>
    </>
  );
};

export default CustomPWAButton;
